/**
 * Service overview dashboard item per the Cloudscape static dashboard pattern:
 * one container with a ColumnLayout "text-grid" of key metrics, separated by
 * vertical dividers, instead of individually tinted metric cards.
 */
import Box from '@cloudscape-design/components/box';
import ColumnLayout from '@cloudscape-design/components/column-layout';
import Container from '@cloudscape-design/components/container';
import Header from '@cloudscape-design/components/header';
import Spinner from '@cloudscape-design/components/spinner';
import { KeyIndicatorCard, KeyIndicatorCardProps } from './KeyIndicatorCard';

export interface KeyIndicatorsGridProps {
  indicators: KeyIndicatorCardProps[];
  loading?: boolean;
}

export function KeyIndicatorsGrid({ indicators, loading }: KeyIndicatorsGridProps) {
  return (
    <Container
      header={
        <Header variant="h2" description="Key ticket health indicators for the last 7 days.">
          Service overview
        </Header>
      }
    >
      {loading ? (
        <Box textAlign="center" padding="l">
          <Spinner size="large" />
        </Box>
      ) : (
        <ColumnLayout columns={3} variant="text-grid" minColumnWidth={170}>
          {indicators.map((indicator) => (
            <KeyIndicatorCard key={indicator.label} {...indicator} />
          ))}
        </ColumnLayout>
      )}
    </Container>
  );
}
